import { DIMENSIONI } from "@/data/simulatorQuestions";

const C = 50, R = 34;
const pt = (i, r) => {
  const a = ((-90 + i * 60) * Math.PI) / 180;
  return [C + Math.cos(a) * r, C + Math.sin(a) * r];
};
const ring = (f) => DIMENSIONI.map((_, i) => pt(i, R * f).join(",")).join(" ");

export const ArchetypeGlyph = ({ dims }) => {
  const on = DIMENSIONI.map((d) => dims.includes(d.sigla));
  const shape = on.map((v, i) => pt(i, R * (v ? 0.98 : 0.4)).join(",")).join(" ");
  return (
    <svg viewBox="0 0 100 100" className="arch-glyph h-20 w-20 overflow-visible" aria-hidden="true">
      {[1, 0.66, 0.33].map((f) => (
        <polygon key={f} points={ring(f)} fill="none" stroke="#23262b" strokeWidth="1" />
      ))}
      {on.map((v, i) => {
        const [x, y] = pt(i, R);
        return <line key={i} x1={C} y1={C} x2={x} y2={y} stroke={v ? "rgba(0,229,255,0.45)" : "#1c1e22"} strokeWidth="1" />;
      })}
      <polygon points={shape} fill="rgba(0,229,255,0.2)" stroke="#00e5ff" strokeWidth="1.6" strokeLinejoin="round" className="arch-glyph-shape" />
      {on.map((v, i) => {
        if (!v) return null;
        const [x, y] = pt(i, R * 0.98);
        return <circle key={i} cx={x} cy={y} r="3" fill="#00e5ff" />;
      })}
    </svg>
  );
};
